/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-06 10:43:05
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import InputNumber from 'src/types/iview/InputNumber'
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import SaasAccountConfigApi, { SaasAccountConfigDOI } from './api/saasAccountConfigApi';
import RegexCheck from 'src/util/regexCheck';
import { createNamespace } from 'src/util/bem';
import Upload from 'src/types/iview/Upload';
import { LoginDOI } from 'src/pages/login/loginApi';
import LocalStore from 'src/util/LocalStore';

export namespace SaasAccountOperateVOI {
    export interface PropsI {
        operate: string;
        row?: SaasAccountConfigDOI.RowDataI;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        user_id?: Integer;
        account_name: string;
        name: string;
        mobile: string;
        passwords?: string;
        confirmPassword?: string;
        expiration_time?:Integer;
        system_name?:string;
        english_system_name?:string;
        logo_url?:string;
    }
}

@Component
class SaasAccountOperateModal extends Vue.Component<SaasAccountOperateVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Object,
    })
    row!: SaasAccountConfigDOI.RowDataI;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: SaasAccountOperateVOI.FormDataI = {
        account_name: '',
        name: '',
        mobile: '',
        passwords: '',
        confirmPassword: '',
        expiration_time:0,
        system_name:'',
        english_system_name:'',
        logo_url:'',
    };
    rules: any = {};

	fileFormate: string[] = ['jpg', 'jpeg', 'png'];

    uploading: boolean = false;

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    get headers() {
        let headers:any = {}
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        headers.access_token = userInfo.access_token || '';
        headers.OperationPlatform = 'Web';
        return headers
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        let params: SaasAccountConfigDOI.OperateParamsI = {
            ...this.formData,
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await SaasAccountConfigApi.add(params);
                break;
            case EnumOperates.Update.getName():
                res = await SaasAccountConfigApi.update(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    mounted() {
        if (this.operate === EnumOperates.Update.getName()) {
            this.formData = {
                user_id: this.row.id,
                account_name: this.row.account_name,
                name: this.row.real_name,
                mobile: this.row.mobile,
                expiration_time:0,
                system_name:this.row.system_name,
                english_system_name:this.row.english_system_name,
                logo_url:''
            };
        }
    }
    created() {
        let t = this;
        this.rules = {
            mobile: [{ validator: RegexCheck.checkMobilePhone, trigger: 'blur' }],
            confirmPassword: [
                {
                    validator: (rule, value, callback) => {
                        if ((t.formData.confirmPassword!== t.formData.passwords)) {
                            callback(new Error('两次输入密码不同'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
        };
    }

    uploadSuccess(res) {
        Toast.success(res.message)
        this.uploading = false;
        if(res.code===0) {
            this.formData.logo_url=res.data.url;
        } 
    }

    checkFileExtension(fileName) {
        const lowerCaseFileName = fileName.toLowerCase();
        return lowerCaseFileName.endsWith('.png') || lowerCaseFileName.endsWith('.jpg') || lowerCaseFileName.endsWith('.jpeg');
    }

    render(h) {
        return (
            <Modal title={this.operate + 'saas账号'} width="500" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="账号名称" prop="account_name" required>
                        <Input v-model={this.formData.account_name} placeholder="请输入" />
                    </form-item>
                    <form-item label="管理员姓名" prop="name" required>
                        <Input v-model={this.formData.name} placeholder="请输入" />
                    </form-item>
                    <form-item label="管理员手机" prop="mobile" required>
                        <Input v-model={this.formData.mobile} placeholder="请输入" />
                    </form-item>
                    <form-item label="有效期(月)" prop="expiration_time" number>
                        <InputNumber max={1200} min={0} v-model={this.formData.expiration_time} placeholder="请输入" />
                    </form-item>
                    <form-item label="系统名称" prop="system_name" required>
                        <Input maxlength={30} v-model={this.formData.system_name} placeholder="请输入系统名称建议10个字符内" />
                    </form-item>
                    <form-item label="系统英文名称" prop="english_system_name">
                        <Input v-model={this.formData.english_system_name} placeholder="请输入系统名称" />
                    </form-item>
                    <form-item label="上传logo"  style="display: inline-block;width:90%">
                        <Upload
                            class="lims-file-upload"
                            action="/ops/files/upload"
                            show-upload-list={false}
                            name="accessory"
                            headers={this.headers}
                            on-success={this.uploadSuccess}
                            accept="image/*"
                            before-upload={(file) => {
                                if (!this.checkFileExtension(file.name)) {
                                    Toast.error('文件格式不正确');
                                    return false;
                                }
                                this.uploading = true;
                            }}
                        >
                                <Button class={createNamespace('upload-btn')} icon="ios-cloud-upload-outline" loading={this.uploading}>上传附件</Button>
                        </Upload>
                        <div class={createNamespace('upload-text')}>支持扩展名： .png .jpg .jpeg 文件大小必须小于等于120*110</div>
                    </form-item>
                    <div v-if={this.operate === EnumOperates.Add.getName()}>
                    <div style="width: 0px;display: inline-block;overflow: hidden">
                        <input ></input>
                    </div>
                        <form-item label="密码" prop="passwords" required >
                            <Input v-model={this.formData.passwords} placeholder="请输入" type="password" autocomplete="off"/>
                        </form-item>
                        <form-item label="确认密码" prop="confirmPassword" required >
                            <Input v-model={this.formData.confirmPassword} placeholder="请输入" type="password" autocomplete="off"/>
                        </form-item>
                    </div>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertSaasAccountOperateModal(operate: string, row?: SaasAccountConfigDOI.RowDataI): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<SaasAccountOperateVOI.PropsI>(SaasAccountOperateModal)({
            row,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
